import React from 'react';
import classnames from 'classnames';
import { connect } from '@cerebral/react';
import { signal, state } from 'cerebral/tags';

// import baseActivityOverviewTheme from './ActivityOverview.scss';
import theme from './ActivityOverview.scss';

const answerColors = {
    'Voor mezelf': theme.me,
    'Voor mama/papa': theme.parents,
    'Voor school': theme.school,
};

class ActivityOverview extends React.Component {
    componentDidMount = () => {
        const { onStateChange } = this.props;
        onStateChange(true);
    };

    componentWillUnmount() {
        const {
            part,
            section,
            // setAnswer,
            answerSet,
        } = this.props;

        answerSet({
            part,
            section,
        });
    }

    renderMobileGrid = sortedActivities => (
        <div className={classnames('d-flex flex-wrap', theme.mobileGrid)}>
            <div className={classnames(theme.gridItem)}>
                <span className={classnames(theme.label)}>Leuk / Week</span>
                {sortedActivities.Leuk['Tijdens de week'].length > 0 ? (
                    sortedActivities.Leuk['Tijdens de week'].map(a => (
                        <div
                            key={a.activity}
                            className={classnames(theme.activity, a.classname)}
                        >
                            {a.activity}
                        </div>
                    ))
                ) : (
                    <div className={classnames(theme.activity, theme.none)}>
                        geen activiteiten
                    </div>
                )}
            </div>
            <div className={classnames(theme.gridItem)}>
                <span className={classnames(theme.label)}>Leuk / Weekend</span>
                {sortedActivities.Leuk['Het weekend'].length > 0 ? (
                    sortedActivities.Leuk['Het weekend'].map(a => (
                        <div
                            key={a.activity}
                            className={classnames(theme.activity, a.classname)}
                        >
                            {a.activity}
                        </div>
                    ))
                ) : (
                    <div className={classnames(theme.activity, theme.none)}>
                        geen activiteiten
                    </div>
                )}
            </div>
            <div className={classnames(theme.gridItem)}>
                <span className={classnames(theme.label)}>
                    Niet leuk / Week
                </span>
                {sortedActivities['Niet leuk']['Tijdens de week'].length > 0 ? (
                    sortedActivities['Niet leuk']['Tijdens de week'].map(a => (
                        <div
                            key={a.activity}
                            className={classnames(theme.activity, a.classname)}
                        >
                            {a.activity}
                        </div>
                    ))
                ) : (
                    <div className={classnames(theme.activity, theme.none)}>
                        geen activiteiten
                    </div>
                )}
            </div>
            <div className={classnames(theme.gridItem)}>
                <span className={classnames(theme.label)}>
                    Niet leuk / Weekend
                </span>
                {sortedActivities['Niet leuk']['Het weekend'].length > 0 ? (
                    sortedActivities['Niet leuk']['Het weekend'].map(a => (
                        <div
                            key={a.activity}
                            className={classnames(theme.activity, a.classname)}
                        >
                            {a.activity}
                        </div>
                    ))
                ) : (
                    <div className={classnames(theme.activity, theme.none)}>
                        geen activiteiten
                    </div>
                )}
            </div>
            <div className={theme.legend}>
                {Object.keys(answerColors).map(item => (
                    <div className={theme.legendItem}>
                        <span
                            className={classnames(
                                answerColors[item],
                                theme.legendItemColor
                            )}
                        />
                        {item}
                    </div>
                ))}
            </div>
        </div>
    );

    renderGrid = sortedActivities => (
        <div className={classnames('d-flex flex-wrap', theme.grid)}>
            <div className={classnames(theme.gridItem, theme.topLeft)}>
                <span className={classnames(theme.label, theme.week)}>
                    Week
                </span>
                <span className={classnames(theme.label, theme.fun)}>Leuk</span>
                {sortedActivities.Leuk['Tijdens de week'].map(a => (
                    <div
                        key={a.activity}
                        className={classnames(theme.activity, a.classname)}
                    >
                        {a.activity}
                    </div>
                ))}
            </div>
            <div className={classnames(theme.gridItem, theme.topRight)}>
                <span className={classnames(theme.label, theme.weekend)}>
                    Weekend
                </span>
                {sortedActivities.Leuk['Het weekend'].map(a => (
                    <div
                        key={a.activity}
                        className={classnames(theme.activity, a.classname)}
                    >
                        {a.activity}
                    </div>
                ))}
            </div>
            <div className={classnames(theme.gridItem, theme.bottomLeft)}>
                <span className={classnames(theme.label, theme.notFun)}>
                    Niet leuk
                </span>
                {sortedActivities['Niet leuk']['Tijdens de week'].map(a => (
                    <div
                        key={a.activity}
                        className={classnames(theme.activity, a.classname)}
                    >
                        {a.activity}
                    </div>
                ))}
            </div>
            <div className={classnames(theme.gridItem, theme.bottomRight)}>
                {sortedActivities['Niet leuk']['Het weekend'].map(a => (
                    <div
                        key={a.activity}
                        className={classnames(theme.activity, a.classname)}
                    >
                        {a.activity}
                    </div>
                ))}
            </div>
            <div className={theme.legend}>
                {Object.keys(answerColors).map(item => (
                    <div className={theme.legendItem}>
                        <span
                            className={classnames(
                                answerColors[item],
                                theme.legendItemColor
                            )}
                        />
                        {item}
                    </div>
                ))}
            </div>
        </div>
    );

    render() {
        const { answers = [], part, media } = this.props;
        const sortedActivities = {
            Leuk: {
                'Tijdens de week': [],
                'Het weekend': [],
            },
            'Niet leuk': {
                'Tijdens de week': [],
                'Het weekend': [],
            },
        };

        const sectionAnswers = answers[part];
        if (sectionAnswers) {
            Object.keys(sectionAnswers).forEach((a) => {
                const answer = sectionAnswers[a];
                if (answer) {
                    const sorted =
                        sortedActivities[answer.answers[0]][answer.answers[2]];
                    sorted.push({
                        activity: answer.activity,
                        classname: answerColors[answer.answers[1]],
                    });
                }
            });
        }

        return (
            <div className={`splitview ${theme.splitview}`}>
                <div className="split-left">
                    <h2>Jouw activiteiten</h2>
                    <p>
                        Zo ziet jouw week eruit. Toch nog iets vergeten?
                        Toevoegen kan nog altijd via de knop ‘Vorige’ onderaan.
                    </p>
                    <p>
                        En wat vind je ervan? Hoe ziet het plaatje eruit? Alles
                        boven de lijn vind je leuk. De onderste helft niet. Zijn
                        die twee kanten wat in evenwicht?
                    </p>
                    <p>
                        De kleurtjes tonen je wat je voor jezelf doet, en wat
                        voor anderen. Dat je dingen doet voor je familie is ok,
                        maar er moet ook tijd voor jezelf overblijven. Wat denk
                        je? Zie je te veel paars of valt het wel mee? Zit je
                        week overvol? Of net je weekend?
                    </p>
                    <p>
                        Zijn er dingen waar je graag meer tijd voor wil? Hoe zou
                        je daar tijd voor kunnen vrijmaken? Kan je bijvoorbeeld
                        in je agenda of op een kalender tijd reserveren voor
                        bepaalde leuke dingen?
                    </p>
                </div>
                <div className={`split-right ${theme.splitRight}`}>
                    {media.medium
                        ? this.renderMobileGrid(sortedActivities)
                        : this.renderGrid(sortedActivities)}
                </div>
            </div>
        );
    }
}

export default connect(
    {
        answerSet: signal`app.answerSet`,
        media: state`useragent.media`,
    },
    ActivityOverview
);



// WEBPACK FOOTER //
// ./src/components/questions/ActivityOverview.js